var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 68 62",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54.645 13.773 6.987 2.33a2 2 0 0 1-1.264 3.794l-4.123-1.374 2.503 4.506a2 2 0 0 1-3.496 1.942l-2.957-5.322-.295.736V27a17.94 17.94 0 0 1-5 12.45v8.34l19.928 10.438a2 2 0 0 1-1.856 3.544l-21-11A2 2 0 0 1 43 49v-6.408A17.922 17.922 0 0 1 34 45a17.929 17.929 0 0 1-9-2.408V49a2 2 0 0 1-1.072 1.772l-21 11a2 2 0 0 1-1.856-3.544L21 47.79v-8.34A17.94 17.94 0 0 1 16 27v-6.615l-3.857-9.642A2 2 0 0 1 14 8h5.469L33.008.264a2 2 0 0 1 1.984 0L48.532 8H54a2 2 0 0 1 1.857 2.743zM20 22v5c0 7.732 6.268 14 14 14s14-6.268 14-14v-5zm-.646-4h29.292l2.4-6H16.954zM40.47 8 34 4.304 27.531 8z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastIcon);
export default __webpack_public_path__ + "static/media/cast-icon.f1581678b15241ca4de1d04eb97e99e4.svg";
export { ForwardRef as ReactComponent };